export default "__VITE_ASSET__fdf01c3c__"